/**** session clear when user enter from menue start  ****/
jQuery(".site-nav__item").click(function() {
  localStorage.clear();
});
